module.exports = __webpack_public_path__ + "static/media/movement_icon.268f45fa.svg";